import type { FetchFunction } from '#layers/base/public';
import type { MonospaceFile } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { createFileHooks } from '~/rstore/utils/collections/files';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';

const FILE_DATETIME_FIELDS = ['createdAt', 'updatedAt'] as const;

export function createWorkspaceFile(workspaceFetch: FetchFunction) {
	return withItemType<MonospaceFile>().defineCollection({
		name: 'MonospaceFile',
		computed: {
			$thumbnail: (item) => item,
		},
		fields: defineSystemDateTimeFields(FILE_DATETIME_FIELDS),
		meta: {
			defaultFields: ['id', 'fileName', 'fileSize', 'mediaType', 'title', 'description', 'tags', 'createdAt', 'updatedAt'],
			primitiveFieldTypes: defineSystemDateTimeFieldTypes(FILE_DATETIME_FIELDS),
		},
		hooks: createFileHooks({ fetch: workspaceFetch, assetsEndpoint: 'assets' }),
	});
}
